import ActionTypes from '../actions/types'
import Constant from '../components/Amenities/AmenitiesConstants'
import moment from 'moment'
import Constants from '../components/Amenities/AmenitiesConstants'

const initialState = {
  amenitiesLookup: {},
  amenityReservationsLookup: {},
  reservationsRequiringApprovalCount: 0,
}

// --------------------------------------------------------------------------------
// State mutation functions:

function setAmenitiesData(state, amenitiesArr) {
  let newLookup = amenitiesArr.reduce((agr, a) => {
    agr[a.id] = a
    return agr
  }, {})

  return {...state, amenitiesLookup: newLookup}
}

function updateSingleAmenity(state, newAmenity) {
  return {...state, amenitiesLookup: {...state.amenitiesLookup, [newAmenity.id]: newAmenity}}
}

function setAmenityReservationsData(state, amenityReservationsArr) {
  let reservationsRequiringApprovalCount = 0
  let newLookup = amenityReservationsArr.reduce((agr, r) => {
    if (r.reservationState === Constant.STATE_REQUESTED && moment(r.startAt) > moment() && !r.originId) {
      reservationsRequiringApprovalCount++
    }
    // Setting state of amenityReservation status to TIMEDOUT if exist in past date and is not approved/denied.
    if (r.reservationState === Constant.STATE_REQUESTED && moment(r.startAt) < moment()) {
      r.reservationState = Constant.STATE_TIMEDOUT
    }

    r.readyForPayment =
      !r.isSystemControlled &&
      r.hourlyCost > 0 &&
      [Constants.STATE_COMPLETED, Constants.STATE_COMPLETED_DELINQUENT].includes(r.reservationState)
    agr[r.id] = r
    return agr
  }, {})

  return {...state, amenityReservationsLookup: newLookup, reservationsRequiringApprovalCount: reservationsRequiringApprovalCount}
}

function addNewAmenityReservation(state, newReservation) {
  return setAmenityReservationsData(state, [...Object.values(state.amenityReservationsLookup), newReservation])
}

function updateExistingAmenityReservation(state, updatedReservation) {
  return setAmenityReservationsData(state, [
    // keep all the other ones,
    ...Object.values(state.amenityReservationsLookup).filter(r => r.id !== updatedReservation.id),
    // add our updated one back to the list
    updatedReservation,
  ])
}

function markBookingPaymentId(state, amenityReservationId, paymentId) {
  let updatedReservation = {
    ...state.amenityReservationsLookup[amenityReservationId],
    bookingPaymentId: paymentId,
    reservationState: Constant.STATE_COMPLETED_PAID,
  }
  return updateExistingAmenityReservation(state, updatedReservation)
}

function refreshAmenityReservation(state, amenityReservationId) {
  let updatedReservation = {...state.amenityReservationsLookup[amenityReservationId]}
  return updateExistingAmenityReservation(state, updatedReservation)
}

// --------------------------------------------------------------------------------

export default function (state = initialState, action) {
  switch (action.type) {
    case ActionTypes.AMENITIES_LOAD_ALL:
      return setAmenitiesData(state, action.payload)

    case ActionTypes.AMENITIES_LOAD_RESERVATIONS:
      return setAmenityReservationsData(state, action.payload)

    case ActionTypes.AMENITIES_UPDATE_SINGLE:
      return updateSingleAmenity(state, action.payload)

    case ActionTypes.AMENITY_RESERVATIONS_CREATE_NEW:
      return addNewAmenityReservation(state, action.payload)

    case ActionTypes.AMENITY_RESERVATIONS_UPDATE_EXISTING:
      return updateExistingAmenityReservation(state, action.payload)

    case ActionTypes.AMENITY_RESERVATIONS_MARK_AS_PAID:
      return markBookingPaymentId(state, action.amenityReservationId, action.paymentId)

    case ActionTypes.AMENITY_RESERVATIONS_REFUND_DEPOSIT:
      return refreshAmenityReservation(state, action.amenityReservationId)

    default:
      /* pass through */
      return state
  }
}
